export const addClass = (element, className) => {
    element.classList.add(className);
}

export const removeClass = (element, className) => {
    element.classList.remove(className);
}

export const makeRequest = async (method, url, data = null) => {
    const response = await fetch(url, {
        method: method,
        body: data,
    });

    return response.json();
}
